module.exports = __webpack_public_path__ + "static/media/facebook-black.ec447b74.png";